import * as React from 'react';
import { ChannelsPublicationFeature } from '@app/src/views/StepTwo/channelPublication';

export const StepTwo: React.FC = () => (
  <React.Fragment>
    <ChannelsPublicationFeature />
  </React.Fragment>
);
